import React, { useEffect, useState } from "react";
import {
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
  getKeyValue,
  Chip,
  useDisclosure,
  ModalHeader,
  ModalBody,
  Input, // Added Input from nextui
} from "@nextui-org/react";
import {
  AccountOfStore,
  FooterFilterMobile,
  LoaderCustom,
  ModelNext,
} from "../../components";
import { useGetAllAccountApi } from "../../hooks";
import { TAccount } from "../../types";
import { useAccountStore } from "../../store";
import { ROLE } from "../../ultils/constants";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import { Space, Table } from "antd";
import { HiPencilAlt } from "react-icons/hi";
import api from "../../config/client.axios.api";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";

type TAccountItem = {
  key: string;
  name: string;
  role: string;
  status: any;
  age: number | any;
  phoneNumber: any;
  enable: boolean;
  email: string;
};

export default function UserPage() {
  // state
  const [page, setPage] = useState(1);
  const [isLoader, setIsLoader] = useState(false);
  const [users, setUsers] = useState<any>([]);
  const [filteredUsers, setFilteredUsers] = useState<any>([]); // Added for filtered results
  const [searchTerm, setSearchTerm] = useState(""); // Added for search term
  const [userId, setUserId] = useState<any>();
  const [reload, setReload] = useState(false);

  const navigate = useNavigate();

  const { info } = useAccountStore();
  useEffect(() => {
    if (!info || info?.role !== ROLE.ROLE_ADMIN) {
      navigate(path.SIGN_IN);
    }
  }, []);

  // api all account
  const { allAccount, isLoading } = useGetAllAccountApi({ reload });

  const {
    isOpen: isOpenDetailMember,
    onOpen: onOpenDetailMember,
    onOpenChange: onOpenChangeDetailMember,
    onClose: onCloseDetailMember,
  } = useDisclosure();

  const rowsPerPage = 10;
  const pages = Math.ceil(filteredUsers.length / rowsPerPage); // Updated to use filteredUsers

  // useEffect for loader
  useEffect(() => {
    setIsLoader(true);
    setTimeout(() => {
      setIsLoader(false);
    }, 200);
  }, []);

  // useEffect for get data
  useEffect(() => {
    if (allAccount?.data?.length > 0) {
      const usersConvert = allAccount?.data?.map((item: any) => {
        return {
          key: item?.id,
          name: `${item?.firstName} ${item?.lastName}`,
          firstName: item?.firstName,
          lastName: item?.lastName,
          role: item?.role,
          status: item?.locked,
          phoneNumber: item?.phoneNumber,
          enable: item?.enabled,
          email: item?.email,
          url: item?.url,
        };
      });
      setUsers(usersConvert);
      setFilteredUsers(usersConvert); // Initialize filteredUsers
    }
  }, [allAccount, isLoading]);

  // useEffect for search filtering
  useEffect(() => {
    const filtered = users.filter((user: TAccountItem) =>
      user.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, [searchTerm, users]);

  const columns = [
    {
      width: 300,
      title: "name",
      dataIndex: "name",
      key: "name",
    },
    {
      width: 300,
      title: "email",
      dataIndex: "email",
      key: "email",
    },
    {
      width: 200,
      title: "phoneNumber",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      width: 200,
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_: any, record: any) => (
        <Space size="large">
          <div
            className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {
              onOpenDetailMember();
              setUserId(record);
            }}
          >
            <HiPencilAlt className="xl:text-2xl text-xl text-blue-500 cursor-pointer"></HiPencilAlt>
          </div>
          <div
            className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {}}
          >
            <MdDelete className="xl:text-2xl text-xl text-red-500 cursor-pointer" />
          </div>
        </Space>
      ),
    },
  ];

  return (
    <>
      <ModelNext
        isOpen={isOpenDetailMember}
        onOpen={onOpenDetailMember}
        onOpenChange={onOpenChangeDetailMember}
      >
        <ModalHeader className="flex flex-col gap-1 lg:text-base text-base text-photo-time-pink-light">
          Update infomation
        </ModalHeader>
        <ModalBody>
          <div className="w-full flex flex-col gap-3">
            <div className="flex items-center justify-between gap-6">
              <div className="w-1/2 flex flex-col">
                <small>first name</small>
                <input
                  className="outline-none p-[6px] text-sm border-[1px] border-gray-500 rounded-md w-full"
                  defaultValue={userId?.firstName}
                  onChange={(e) => {
                    setUserId((prev: any) => ({
                      ...prev,
                      firstName: e.target.value,
                    }));
                  }}
                ></input>
              </div>
              <div className="w-1/2 flex flex-col">
                <small>last name</small>
                <input
                  className="outline-none p-[6px] text-sm border-[1px] border-gray-500 rounded-md w-full"
                  defaultValue={userId?.lastName}
                  onChange={(e) => {
                    setUserId((prev: any) => ({
                      ...prev,
                      lastName: e.target.value,
                    }));
                  }}
                ></input>
              </div>
            </div>
            <div className="flex items-center justify-between gap-6">
              <div className="w-1/2 flex flex-col">
                <small>first name</small>
                <input
                  className="outline-none p-[6px] text-sm border-[1px] border-gray-500 rounded-md w-full"
                  onChange={(e) => {
                    setUserId((prev: any) => ({
                      ...prev,
                      phoneNumber: e.target.value,
                    }));
                  }}
                  defaultValue={userId?.phoneNumber}
                ></input>
              </div>
              <div className="w-1/2 flex flex-col">
                <small className="text-transparent">first name</small>
                <div
                  onClick={async () => {
                    try {
                      const res = await api.put(`/account?id=${userId?.key}`, {
                        firstName: userId?.firstName,
                        lastName: userId?.lastName,
                        phoneNumber: userId?.phoneNumber,
                        email: userId?.email,
                      });
                      if (res?.data?.code === 200) {
                        setReload(!reload);
                        toast(res?.data?.message || "Cập nhập thành công !");
                      } else {
                        toast(res?.data?.message || "Cập nhập thất bại !");
                      }
                    } catch (error: any) {
                      toast(
                        error?.response?.data?.error || "Cập nhập thất bại !"
                      );
                    }
                    onCloseDetailMember();
                  }}
                  className="outline-none p-[6px] border-[1px] cursor-pointer hover:bg-opacity-90 bg-photo-time-pink-main flex justify-center items-center rounded-md w-full"
                >
                  <span className="text-white text-sm">Cập nhập</span>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModelNext>
      {isLoader && <LoaderCustom></LoaderCustom>}
      <div className="w-[100%] md:pb-2 p-[16px] md:px-[0px] font-semibold text-ok-travel-green mb-2 border-b-[1.5px] md:mb-4">
        <h3 className="uppercase max-md:mt-4 text-medium text-gray-500 md:text-md xl:text-xl">
          Manage User
        </h3>
      </div>
      <div className="mt-4 p-[16px] md:px-[0px]">
        <Input
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="mb-4 max-w-md"
          startContent={
            <svg
              className="w-5 h-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          }
        />
        <Table
          dataSource={filteredUsers}
          columns={columns}
          pagination={false}
        ></Table>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </>
  );
}
